import React, { Component } from 'react';

interface State {
	text: string;
}
interface Props {
	onSearch: (tx: string) => void;
}

export default class SearchBox extends Component<Props, State> {
	state = {
		text: '',
	};

	$searchInput = React.createRef<HTMLInputElement>();

	componentDidUpdate(prevProps: Props, prevState: State) {
		const { text } = this.state;
		const { onSearch } = this.props;

		if (prevState.text !== text) {
			onSearch(text);
		}
	}

	handleInput: React.ChangeEventHandler<HTMLInputElement> = e => {
		const { value } = e.target;

		this.setState({
			text: value.replace(/[^a-zA-Z0-9 ]/g, ''),
		});
	};

	render() {
		const { text } = this.state;

		return (
			<div className="relative my-8 max-w-2xl">
				<svg
					className="absolute top-1/2 transform -translate-y-1/2 ml-4 z-10"
					width="18"
					height="18"
					viewBox="0 0 18 18"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M6.5 0C8.22391 0 9.87721 0.684819 11.0962 1.90381C12.3152 3.12279 13 4.77609 13 6.5C13 8.11 12.41 9.59 11.44 10.73L11.71 11H12.5L17.5 16L16 17.5L11 12.5V11.71L10.73 11.44C9.55055 12.4468 8.05071 12.9999 6.5 13C4.77609 13 3.12279 12.3152 1.90381 11.0962C0.684819 9.87721 0 8.22391 0 6.5C0 4.77609 0.684819 3.12279 1.90381 1.90381C3.12279 0.684819 4.77609 0 6.5 0ZM6.5 2C4 2 2 4 2 6.5C2 9 4 11 6.5 11C9 11 11 9 11 6.5C11 4 9 2 6.5 2Z"
						fill="#808A9B"
					/>
				</svg>
				<input
					className="c-input__text c-searchBox__input pl-16 w-full bg-gray-100"
					autoComplete="off"
					type="search"
					placeholder="Search Coins"
					name="coin"
					id="markets__search"
					value={text}
					ref={this.$searchInput}
					onChange={this.handleInput}
					// onFocus={this.expandBar}
					// onBlur={this.collapseBar}
					required
				/>
			</div>
		);
	}
}
